import { render, staticRenderFns } from "./ProductStockMovementNew.vue?vue&type=template&id=4a8466ee&scoped=true"
import script from "./ProductStockMovementNew.vue?vue&type=script&lang=js"
export * from "./ProductStockMovementNew.vue?vue&type=script&lang=js"
import style0 from "./ProductStockMovementNew.vue?vue&type=style&index=0&id=4a8466ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8466ee",
  null
  
)

export default component.exports